/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-dynamic-delete */
/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import React, { useState, useContext, useEffect } from "react";
import { Link } from "react-router-dom";
import {
  Grid,
  GridColumn as Column,
  getSelectedState,
} from "@progress/kendo-react-grid";
import { process } from "@progress/kendo-data-query";
import { getter } from "@progress/kendo-react-common";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
  Card,
  CardContent,
  CardDescription,
} from "@repo/ui";
import { format, formatDate } from "date-fns";
import { UserContext } from "utils/reducers/user";
import { isOperationAllowed, showToast } from "utils/helper";
import { useGetShiftRoutes } from "utils/apis/lookups.api";
import Layout from "components/layout";
import {
  useAssignDeliveryRoute,
  useCancelDeliveryOrder,
  useGetDeliveriesOrders,
} from "utils/apis/deliveries.api";
import FilterBar from "components/filterBar";
import { Permissions } from "utils/enums";
import { saveFilters } from "utils/actions/user";

const initialDataState = {
  sort: [
    {
      field: "code",
      dir: "asc",
    },
  ],
  take: 25,
  skip: 0,
};

const currentDate = new Date();

export default function Deliveries() {
  const user = useContext(UserContext);
  const [dataState, setDataState] = useState<any>(initialDataState);
  const [selectedState, setSelectedState] = useState<any>({});
  const DATA_ITEM_KEY = "requestId";
  const SELECTED_FIELD = "selected";
  const idGetter = getter(DATA_ITEM_KEY);

  const [ddlInRouteTeams, setDdlInRouteTeams] = useState("");
  const [filters, setFilters] = useState<any>(user.filters?.deliveries || {});
  const [selectedRequests, setSelectedRequests] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 25;

  const { data: inRouteTeams } = useGetShiftRoutes({
    cashCenterId: user?.CashCenterId,
    shift: "morning",
    operationDate: formatDate(
      filters?.operationDate?.id || currentDate,
      "yyyy-MM-dd'T'00:00:00.000'Z'",
    ),
  });

  const { mutate: cancelDeliveryOrder, isSuccess: cancelSuccess } =
    useCancelDeliveryOrder();

  const { mutate: assignDeliveryRoute, isSuccess: successDeliveryRoute } =
    useAssignDeliveryRoute();

  const {
    isSuccess: requestSuccess,
    data: requestsData,
    isPending: loadingRequests,
  } = useGetDeliveriesOrders({
    pageNumber: currentPage || 1,
    pageRowCount: pageSize,
    searchCriteria: filters?.search?.id.length >= 3 ? filters?.search?.id : "",
    operationDate: formatDate(
      filters?.operationDate?.id || currentDate,
      "yyyy-MM-dd'T'00:00:00.000'Z'",
    ),
    cashCenterId: user.CashCenterId,
    customerId: filters?.customer?.id || "",
    sourceSPId: filters?.sourceSPId?.id || "",
  });

  const onSelectionChange = (event: any) => {
    const newSelectedState = getSelectedState({
      event,
      selectedState,
      dataItemKey: DATA_ITEM_KEY,
    });

    setSelectedState(newSelectedState);

    const selections = Object.keys(newSelectedState).map((key) => ({
      itemKey: key,
      isSelected: newSelectedState[key],
    }));

    const selectedJobs = selections.filter((req) => req.isSelected === true);

    const requestIds: any = selectedJobs.map((req) => ({
      itemKey: req.itemKey,
    }));

    setSelectedRequests(requestIds);
  };

  const onHeaderSelectionChange = (event: any) => {
    const checkboxElement = event.syntheticEvent.target;
    const checked = checkboxElement.checked;
    const newSelectedState: any = {};

    event.dataItems.forEach((item: any) => {
      newSelectedState[idGetter(item)] = checked;
    });

    setSelectedState(newSelectedState);

    const selections = Object.keys(newSelectedState).map((key) => ({
      itemKey: key,
      isSelected: newSelectedState[key],
    }));

    const selectedRequests: any = selections.filter(
      (req) => req.isSelected === true,
    );

    const requestIds = selectedRequests.map((req: any) => ({
      itemKey: req.itemKey,
    }));

    setSelectedRequests(requestIds);
  };

  const onPageChange = (e: any) => {
    const _page = e.page.skip / pageSize + 1;
    setCurrentPage(_page);
  };

  function ShowDetailsButtonCell(props: any) {
    const { requestId, jobNo, orderId } = props.dataItem;
    return (
      <td
        className="text-center"
        {...props}
        onClick={(e: Event) => {
          e.stopPropagation();
          props.selectionChange(props.dataItem);
        }}
      >
        {isOperationAllowed(Permissions.Delivery, Permissions.View) ? (
          <Link
            to="/deliveries-detail"
            state={{
              requestId,
              jobNo,
            }}
          >
            {orderId}
          </Link>
        ) : (
          orderId
        )}
      </td>
    );
  }

  const onBtnAssignRouteClicked = () => {
    if (selectedRequests.length === 0) {
      showToast("error", "No job selected to assign route.");
      return;
    }

    if (!ddlInRouteTeams) {
      showToast("error", "Please select route to assign.");
      return;
    }

    const routeNo = ddlInRouteTeams;

    const requestsIds = selectedRequests.map((sr: any) => ({
      requestId: sr.itemKey.split("_")[0],
      jobNo: sr.itemKey.split("_")[1],
    }));

    const selectedRoute: any = inRouteTeams?.find(
      (item: any) => item?.routeNo === ddlInRouteTeams,
    );

    const assignmentDto: any = {
      cashCenterId: filters?.cashCenter || user?.CashCenterId,
      operationDate: formatDate(
        filters?.operationDate?.id || currentDate,
        "yyyy-MM-dd'T'00:00:00.000'Z'",
      ),
      routeNo,
      requests: requestsIds,
      shift: "morning",
      fieldTeam: selectedRoute?.fieldTeam,
    };

    assignDeliveryRoute(assignmentDto);
  };

  const onBtnCancelClicked = () => {
    if (selectedRequests.length === 0) {
      showToast("error", "Selected job to cancel.");
      return;
    }

    const requestsIds = selectedRequests.map((sr: any) => ({
      requestId: sr.itemKey.split("_")[0],
      jobNo: sr.itemKey.split("_")[1],
    }));

    cancelDeliveryOrder(requestsIds);
  };

  useEffect(() => {
    if (cancelSuccess) {
      setSelectedState({});
    }
  }, [cancelSuccess]);

  useEffect(() => {
    if (successDeliveryRoute) {
      setDdlInRouteTeams("");
      setSelectedState({});
    }
  }, [successDeliveryRoute]);

  useEffect(() => {
    if (requestSuccess && requestsData?.data) {
      setTotalRecords(requestsData?.totalRecords);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [requestSuccess, requestsData?.data]);

  const handleChangeFilter = (value: string, key: string) => {
    setCurrentPage(1);
    let newFilters = {};
    if (!value) {
      const updatedFilter = { ...filters };
      delete updatedFilter[key];
      setFilters({
        ...updatedFilter,
      });
      saveFilters(user.dispatch, {
        ...user.filters,
        deliveries: updatedFilter,
      });
      return;
    }
    if (["operationDate", "search"].includes(key)) {
      newFilters = {
        ...filters,
        [key]: {
          name: key === "operationDate" ? format(value, "PPP") : value,
          id: value,
        },
      };
    } else {
      const { sourceSPId, ...remainingFilters } = filters;
      newFilters = {
        ...(key === "customer" ? remainingFilters : filters),
        [key]: JSON.parse(value),
      };
    }
    setFilters(newFilters);
    saveFilters(user.dispatch, { ...user.filters, deliveries: newFilters });
  };

  return (
    <Layout>
      <Breadcrumb className="mt-5 mx-4">
        <BreadcrumbList>
          <BreadcrumbItem>
            <Link to="/dashboard">Home</Link>
          </BreadcrumbItem>
          <BreadcrumbSeparator />
          <BreadcrumbItem>
            <BreadcrumbPage>Deliveries </BreadcrumbPage>
          </BreadcrumbItem>
        </BreadcrumbList>
      </Breadcrumb>
      <Card className="mx-4 mt-5">
        <CardContent>
          <CardDescription className="pt-6">
            <FilterBar
              handleChangeFilter={handleChangeFilter}
              onBtnCancelClicked={onBtnCancelClicked}
              isCancel={!selectedRequests.length}
              onBtnAssignRouteClicked={onBtnAssignRouteClicked}
              setFilters={setFilters}
              filters={filters}
              inRouteTeams={inRouteTeams}
              ddlInRouteTeams={ddlInRouteTeams}
              setDdlInRouteTeams={setDdlInRouteTeams}
              isOnward
            />

            <div className="border-bo my-5 bg-accent" />
            {loadingRequests ? (
              loadingPanel
            ) : (
              <Grid
                dataItemKey={DATA_ITEM_KEY}
                selectedField={SELECTED_FIELD}
                selectable={{
                  enabled: true,
                  drag: true,
                  cell: false,
                  mode: "multiple",
                }}
                data={process(
                  requestsData?.data?.map((req: any) => ({
                    ...req,
                    [SELECTED_FIELD]: selectedState[idGetter(req)],
                  })) || [],
                  { ...dataState, skip: 0 },
                )}
                {...dataState}
                onDataStateChange={(e) => {
                  setDataState(e.dataState);
                }}
                sortable
                filterable
                pageable
                total={totalRecords}
                pageSize={pageSize}
                skip={(currentPage - 1) * pageSize}
                onPageChange={onPageChange}
                onSelectionChange={onSelectionChange}
                onHeaderSelectionChange={onHeaderSelectionChange}
                size="small"
              >
                <Column
                  field={SELECTED_FIELD}
                  filterable={false}
                  width="40px"
                  headerSelectionValue={
                    requestsData?.data
                      ?.map((req: any) => ({
                        ...req,
                        itemKey: `${req.requestId}_${req.jobNo}`,
                        selected: false,
                      }))
                      ?.findIndex(
                        (item: any) => !selectedState[idGetter(item)],
                      ) === -1
                  }
                  className="text-center"
                />
                <Column
                  cell={ShowDetailsButtonCell}
                  field="orderId"
                  title="Order Id"
                  width={160}
                />
                <Column field="jobNo" title="Job #" width={90} />
                <Column field="customer" title="Customer" width={190} />
                <Column field="source" title="Source Location" width={160} />
                <Column field="barcode" title="Barcode" width={160} />
                <Column
                  field="destination"
                  title="Onward Location"
                  width={160}
                />
                <Column
                  field="routeNo"
                  title="Route"
                  width={140}
                  className="text-center"
                />

                <Column field="jobNature" title="Job Nature" width={110} />

                <Column
                  field="status"
                  title="Status"
                  className="text-center"
                  width={140}
                />

                <Column field="requestedBy" title="Requested By" width={140} />
                <Column field="remarks" title="Remarks" width={200} />
                <Column title="Actions" width="120px" />
              </Grid>
            )}
          </CardDescription>
        </CardContent>
      </Card>
    </Layout>
  );
}

const loadingPanel = (
  <div className="k-loading-mask">
    <span className="k-loading-text">Loading</span>
    <div className="k-loading-image" />
    <div className="k-loading-color" />
  </div>
);
